import { JardinTutoria } from 'src/app/model/JardinTutoria.model';
import { AulaVirtualComponent } from '../../aula-virtual.component';
import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
  ElementRef,
  Input,
  Inject,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarDateFormatter,
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
  DAYS_OF_WEEK,
} from 'angular-calendar';
import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { TutoriaService } from 'src/app/service/tutoria.service';
import { AgendarTutoria, ResponseTutor, Tutor } from 'src/app/model/Tutor.model';
import { ResponseAllTutorDisponibilidades, ResponseTutorDisponibilidadObject, TutorDisponibilidad } from 'src/app/model/TutorDisponibilidad';
import Swal from 'sweetalert2';


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};


@Component({
  selector: 'app-agendar',
  templateUrl: './agendar.component.html',
  styleUrls: ['./agendar.component.css']
})
export class AgendarComponent implements OnInit {
  
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @Input()jardinTutoria: JardinTutoria;
  @Input() simulacion: boolean;
  @ViewChild('divSpinner') divSpinner:ElementRef;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  locale: string = 'es-CL';
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  events: CalendarEvent[] = [];
  refresh = new Subject<void>();
  activeDayIsOpen: boolean = true;
  tutor : Tutor;
  cargando:boolean;

  constructor(
    private modal: NgbModal,
    private storageService: StorageService,
    private tutorService: TutorService,
    private tutoriaService:TutoriaService,
    @Inject(AulaVirtualComponent) private parent: AulaVirtualComponent
  ) {}



  
  ngOnInit(): void {
    this.cargando = true;
    this.events = new Array<CalendarEvent>();
    this.obtenerMiTutor();
    
  
  }

  obtenerMiTutor(){
    if(this.simulacion){
      this.tutor = this.tutorService.tutor;
      this.cargaHorasTutor(); 
    }else{
      this.tutoriaService.API_POST_getMyTutor(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseTutor) => {
        this.tutor = response.payload; 
        this.cargaHorasTutor(); 
      },
      (err) => {
        console.log("error"+err)
      });
    }
  }


 cargaHorasTutor(){
  this.tutoriaService.API_POST_getTutorDisponibilidad(this.tutor.idPersonaPeriodo,this.jardinTutoria.idJardinPeriodoTutoria).subscribe((response: ResponseAllTutorDisponibilidades) => {
    response.payload.forEach(function(entry) {

      let fechaInicio = new Date(entry.fechaInicio.toString());
      let fechaFin = new Date(entry.fechaFin.toString());

      fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
      fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

      if(entry.idEstado === 145){
        let calendarEvent: CalendarEvent = {
          id : entry.idTutorDisponibilidad,
          title: 'Disponible',
          color: colors.blue,
          start: fechaInicio,
          end: fechaFin,
          draggable: false,
        };
        this.events.push(calendarEvent);
        this.refresh.next();
      }
      
    }, this);
    this.events = [...this.events];
    this.refresh;
    this.cargando = false;
    this.divSpinner.nativeElement.style.display='none';
  },
  (err) => {
    this.cargando = false;
    this.divSpinner.nativeElement.style.display='none';
    console.log("error"+err)
    Swal.fire({
      title: 'UPS!',
      text: 'A la espera de confirmación horarios tutor',
      icon: 'info',
      confirmButtonText: 'OK'
    })
  })
 }

  modalData: {
    action: string;
    event: CalendarEvent;
    tutor: Tutor;
  };

   

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }


  changeDay(date: Date) {
    this.cargando = true;
    this.viewDate = new Date(date);
    this.view = CalendarView.Week;
    this.cargando = false;
  }

  agendarModal(action: string, event: CalendarEvent): void {
    var tutor = this.tutor;
    this.modalData = { event, action, tutor };
    this.modal.open(this.modalContent, { size: 'lg' });
  }


  confirmarAgenda(modalData){
    var agendarTutoria = new AgendarTutoria();
    agendarTutoria.idJardinPeriodoTutoria = this.jardinTutoria.idJardinPeriodoTutoria;
    agendarTutoria.idTutorDisponibilidad = modalData.event.id;
    this.divSpinner.nativeElement.style.display='';
    this.modal.dismissAll();
    this.tutoriaService.API_POST_agendarTutoria(agendarTutoria).subscribe((response: any) => {
      this.divSpinner.nativeElement.style.display='none';
      if(response.payload){
        this.volver();
      }else{
        Swal.fire({
          title: 'Ups!',
          text: 'La hora ya fue tomada por otra Unidad Educativa',
          icon: 'error',
          confirmButtonText: 'OK'
        }).then((result) => {
          this.ngOnInit();
        })
      }
     
    },
    (err) => {
      console.log("error"+err)
    })
    
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }



  volver(){
    this.parent.ngOnInit();
    this.parent.showAgenda = false;
  }

}
